<template>
    <c-dialog ref="dialog" mode="slide" width="50vw" :title="moduleTitle">
        <c-form ref="form" unit-width="100%">
            <c-form-item v-if="isNotice" label="公告栏目" required>
                <c-select v-model="consultation_id" :options="consultations"></c-select>
            </c-form-item>
            <c-form-item v-show="articleType != 0" :label="config.titleLabel" required>
                <c-input v-model="title" maxlength="200"></c-input>
            </c-form-item>
            <c-form-item v-if="isNotice" label="摘要">
                <c-input v-model="summary" maxlength="500"></c-input>
            </c-form-item>
            <c-form-item v-if="isNotice" label="是否标新">
                <c-select v-model="is_new" :options="[{name: '是', value: 1}, {name: '否', value: 2}]"></c-select>
            </c-form-item>
            <c-form-item label="内容" required>
                <c-editor v-model="content" :height="600"></c-editor>
            </c-form-item>
        </c-form>
        <template slot="button">
            <c-button color="main" size="dialog" @click="save">保存</c-button>
            <c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
//文章类型配置 article_type 0-单页 1-公告 2-教程
const ARTICLE_TYPES = {
    'single-page': {articleType: 0, name: '单页', titleLabel: '页面标题'},
    'notice': {articleType: 1, name: '公告', titleLabel: '标题', notice: true},
    'guide': {articleType: 2, name: '教程', titleLabel: '标题'},
    'rule': {articleType: 3, name: '规则', titleLabel: '标题'}
};

export default {
    name: 'systemArticleEdit',
    props: {id: [String, Number], type: String},

    data() {
        return {
            consultations: [],
            consultation_id: '',
            title: '',
            summary: '',
            is_new: 2,
            content: '',
            file_url: '',
        };
    },

    computed: {
        config() {
            return ARTICLE_TYPES[this.type] || {};
        },

        articleType() {
            return this.config.articleType;
        },

        isNotice() {
            return !!this.config.notice;
        },

        moduleTitle() {
            return (this.id ? '编辑' : '新增') + (this.config.name || '文章');
        },
    },

    methods: {
        open() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$refs.dialog.open();
            if (this.isNotice) {
                this.request({
                    url: '/consultation/list',
                    data: {state: 1},
                    success: data => {
                        this.consultations = (data || []).map(item => ({name: item.name, value: item.id}));
                    },
                });
            }
            if (this.id) {
                this.request({
                    url: '/article/detail',
                    data: {id: this.id, article_type: this.articleType},
                    success: data => {
                        ['consultation_id', 'title', 'summary', 'content','file_url'].forEach(key => {
                            this[key] = data[key] == null ? '' : data[key];
                        });
                        this.is_new = Number(data.is_new) === 1 ? 1 : 2;
                    },
                });
            }
        },

        /******保存文章*********/
        save() {
            if (
                (this.isNotice && !this.consultation_id)
                ||!this.title
                ||!this.content
            ) {
                this.$message({message: '请完整填写必填项', type: 'error'});
                return;
            }
            const data = {
                id: this.id,
                article_type: this.articleType,
                title: this.title,
                content: this.content,
                file_url: this.file_url
            };
            if (this.isNotice)
                Object.assign(data, {
                    consultation_id: this.consultation_id,
                    summary: this.summary,
                    is_new: this.is_new,
                });
            this.request({
                url: '/article/edit',
                data,
                success: () => {
                    this.$message({message: '保存成功', type: 'success'});
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                },
            });
        },
    },
};
</script>
